// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZGNL","right":"styles_right__2mn-_"};